import { useMemo } from 'react';

import { themeQuartz } from 'ag-grid-enterprise';

import { ROW_HEIGHT } from '@/constants/grid';

/**
 * Custom React hook that returns a memoized AG Grid theme configuration
 * based on the `themeQuartz` preset with specific parameters for colors,
 * fonts, and layout.
 *
 * @returns {object} The AG Grid theme configuration object.
 *
 * @example
 * const gridTheme = useDefaultGridTheme();
 * // Use `gridTheme` as the theme for your AG Grid instance
 */
export const useDefaultGridTheme = () => {
  return useMemo(() => {
    return themeQuartz.withParams({
      accentColor: '#3182CE',
      borderRadius: 0,
      cellFontFamily: 'monospace',
      cellHorizontalPadding: 8,
      headerBackgroundColor: '#2C5282',
      headerFontWeight: 'bold',
      headerHeight: ROW_HEIGHT,
      headerTextColor: '#F5F5F5',
      oddRowBackgroundColor: '#F0F0F0',
      rowHeight: ROW_HEIGHT,
      rowVerticalPaddingScale: 0,
      wrapperBorderRadius: 0,
    });
  }, []);
};
